const hlsTags = {
  DISCONTINUITY: 'DIS',
  DATERANGE: 'EXT-X-DATERANGE',
};

export default hlsTags;
